import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { getBuildStageEndPoint } from '../utils/axiosFetch';

const API_SUPPORT = axios.create({ baseURL: getBuildStageEndPoint('support.gov-us-1') });

API_SUPPORT.interceptors.response.use(
  (response) => response,
  ({ response, request, message }: AxiosError<SupportRequestError>) => {
    return Promise.reject({
      message: `${response?.data?.message || message || request}`,
      status: response?.status as number,
    });
  }
);

export const useSendSupportRequest = (
  c1Token: string
): UseMutationResult<
  SupportRequestSuccess,
  { message: string; status: number },
  SupportRequestData,
  SupportRequestSuccess
> =>
  useMutation(async (supportRequestData) => {
    const { data }: { data: SupportRequestSuccess } = await API_SUPPORT.post(
      '/requests',
      supportRequestData,
      {
        headers: {
          'api-version': 'v1',
          Accept: 'application/json',
          Authorization: `Bearer ${c1Token}`,
        },
      }
    );

    return data;
  });
